const BRAND_MAIN = "#0078CF";
const BRAND_DARK = "#005AA3";
const BRAND_LIGHT = "#069BD7";

const SECONDARY_MAIN = "#636363";
const SECONDARY_DARK = "#2A2A2A";
const SECONDARY_LIGHT = "#E6E6E6";

const SUCCESS_MAIN = "#00882B";
const SUCCESS_LIGHT = "#98e698";

const WARNING_MAIN = "#FDEE8A";

const ERROR_MAIN = "#D93927";
const ERROR_DARK = "#94000F";

const GREY_100 = "#F8FBFF";
const GREY_200 = "#EFEFEF";
const GREY_300 = "#E5E5DC";
const GREY_400 = "#A5A5A5";
const GREY_600 = "#636363";
const GREY_700 = "#312f35";
const GREY_900 = "#2A2A2A";

const BLUE_100 = "#EDF3F8";
const BLUE_300 = "#B6E1EA";
const BLUE_500 = "#0078CF";
const BLUE_600 = "#026CB8";
const BLUE_700 = "#005AA3";

export const THEME_COLOR_PALETTE = {
  primary: {
    main: BRAND_MAIN, // use with bg + text, buttons + icons, links, borders + dividers
    dark: BRAND_DARK,
    light: BRAND_LIGHT, // ConEd brand color - use with logos, accent bars, navigation states
  },
  secondary: {
    main: SECONDARY_MAIN,
    dark: SECONDARY_DARK,
    light: SECONDARY_LIGHT,
  },
  success: {
    main: SUCCESS_MAIN,
    light: SUCCESS_LIGHT,
  },
  info: {
    100: BLUE_100,
    300: BLUE_300,
    500: BLUE_500,
    600: BLUE_600,
    700: BLUE_700,
  },
  warning: {
    main: WARNING_MAIN,
  },
  error: {
    main: ERROR_MAIN,
    dark: ERROR_DARK,
  },
  grey: {
    100: GREY_100,
    200: GREY_200,
    300: GREY_300,
    400: GREY_400,
    600: GREY_600,
    700: GREY_700,
    900: GREY_900,
  },
};
